import React from 'react';
import {Link} from 'react-router-dom'
import FeatherIconWrapper from '../Icons/FeatherIconWrapper'
import AvailableOfflineIndicator from '../AvailableOfflineIndicator/AvailableOfflineIndicator'
import UserIcon from '../Icons/User/User'
import {WerfenColor, White} from '../../Constants/ColorChart'
import {connect} from 'react-redux'
import "./ProfileIcon.css";
import {IconContainer} from '../ResultTable/Components/ResultRow/StyledResultRow';
import {DownloadState} from "../../../Download/Reducer/Download";
import DocumentDownload from "../../../Download/Entity/DocumentDownload";

const ProfileIcon = (props: mapStateToPropsType) => {
    const {isNetworkAvailable, documents} = props;
    const canShowCloudIcon: boolean = isNetworkAvailable && documents.length > 0;

    return (
        <div className="ProfileIconWrapper">
            <IconContainer
                className={"iconContainer iconProfile"}
                data-title={"User settings and favorites"}>
                {canShowCloudIcon &&
                  <div className={"cloudIcon"}>
                      <span className={"iconContainer"}>
                          <AvailableOfflineIndicator
                            color={White}
                            fillColor={WerfenColor}
                            width="30px"
                            onClick={() => {
                            }}
                            unactiveStyle={''}
                            activeStyle={`position: absolute; top: 20px; right: 35px;`}
                            isGlobalIndicator={true}
                            isActive={false}
                            isDownloading={false}
                          />
                      </span>
                  </div>
                }
                <Link to="/profile/settings">
                    <FeatherIconWrapper
                        color={White}
                        fillColor={"none"}
                        width={"33px"}
                        iconStyle={{strokeWidth: "1.3px", "&:hover": {cursor: "pointer"}, marginTop: "-2px"}}
                        fillSecondaryColor={null}
                        onClick={(event: Event): void => {
                        }}
                        isActive={true}
                        className={"ProfileIcon top-bar-icon"}
                        ariaLabel={"Type"}
                        role={null}
                        Icon={UserIcon}
                    />
                </Link>
            </IconContainer>
        </div>
    );
}

type ProfileIconStageProps = {
    sensors: {
        isNetworkAvailable: boolean
    },
    download: DownloadState
}

type mapStateToPropsType = {
    isNetworkAvailable: boolean,
    documents: DocumentDownload[]
}

const mapStateToProps = (state: ProfileIconStageProps): mapStateToPropsType => ({
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    documents: state.download.download
});

export default connect(mapStateToProps, {})(ProfileIcon);
